import axios from "axios";

const PROJECT_ID = "f5rve607";

const PROD_URL_REGEX = /^[A-Za-z0-9-]+\.go\.fanrally\.com$/;
const DATASET = PROD_URL_REGEX.test(location.host) ? "production" : "demo";

// use HTTP instead of sanityClient because createClient from @sanity/client is giving error
export const client = {
  fetch: (query: string) =>
    axios(
      `https://${PROJECT_ID}.api.sanity.io/v2021-06-07/data/query/${DATASET}?`,
      {
        params: {
          query,
        },
      }
    ).then((response) => response.data),
};

export const getSanityImage = (ref: string) => {
  const [_, id, dimension, format] = ref.split("-");
  return `https://cdn.sanity.io/images/${PROJECT_ID}/${DATASET}/${id}-${dimension}.${format}`;
};

export const getImageDimention = (ref: string) => {
  const [_, __, dimensionS] = ref.split("-");
  const [width, height] = dimensionS.split("x").map((v) => parseInt(v, 10));

  return { width, height };
};
